var vmFormQA = null;
var recaptchaError = "";
//function isCaptchaChecked() {
//    return grecaptcha && grecaptcha.getResponse().length !== 0;
//}
function popoverFix() {
  $('[data-toggle="popover"]').popover({
    trigger: "hover",
    html: true,
  });
}
function Callback() {
  vmFormQA.recaptchaCallback();
}
if (document.getElementById("formQA")) {
  Vue.filter("highlight", function (stringToSearch, searchTerm) {
    if (searchTerm === "") return stringToSearch;
    var s = "(" + searchTerm.trim().replace(/ +/g, "|") + ")";
    var iQuery = new RegExp(s, "ig");
    return stringToSearch
      .toString()
      .replace(iQuery, function (matchedText, a, b) {
        return "<span class='highlight'>" + matchedText + "</span>";
      });
  });

  Vue.filter("lowercase", function (value) {
    if (!value) return "";
    value = value.toString();
    return value.toLowerCase();
  });

  Vue.component("input-text", {
    props: [
      "title",
      "id",
      "placeholder",
      "value",
      "error",
      "maxLength",
      "required",
      "validator",
      "labelInfoPopover",
      "description",
      "type",
    ],
    template: `
            <div class="col-md-6 mb-md-4 ">
                <div class="form-group" :class="{'is-invalid': error, 'is-valid': !validator.$invalid && value.length > 0}">
                    <label :for="id"><span v-if="required">*</span>{{title}}</label>
                    <div class="formHelper">
                        <div class="validation-cover">
                            <input :type="type"  
                                class="form-control" 
                                :name="id" 
                                :id="id" 
                                autocomplete="off"
                                :placeholder="placeholder" 
                                v-on:input="$emit('input', $event.target.value), validator.$touch()"/>
                        </div>
                        <template v-if="labelInfoPopover">
                            <a href="javascript:void(0)" class="tooltip-toggle"><i>What's this?</i></a>
                            <div class="tooltip">
                                <div class="tooltip-inner">
                                    <div v-html="labelInfoPopover"></div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-if="description != ''" class="mt-2">{{description}}</div>
                </div>
            </div>`,
  });

  Vue.component("input-time", {
    props: [
      "title",
      "id",
      "placeholder",
      "value",
      "error",
      "required",
      "validator",
      "labelInfoPopover",
      "description",
    ],
    data() {
      return {
        localValue: this.value,
      };
    },
    watch: {
      localValue(newValue) {
        this.$emit("input", newValue);
      },
    },
    methods: {
      onInput(event) {
        this.$emit("input", event);
        if (this.validator) {
          this.validator.$touch();
        }
      },
    },

    template: `
    <div class="col-md-6 mb-md-4 ">
      <div class="form-group form-date" :class="{'is-invalid': error, 'is-valid': !validator.$invalid && value.length > 0}">
        <div class="label"><span v-if="required">*</span>{{title}}</div>
         <div class="validation-cover">
            <b-form-timepicker
                              :id=id
                              locale="en"
                              reset-button
                              today-button
                              :droprleft="true"
                              :right="true"
                              :no-flip="true"
                              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                              :placeholder="placeholder" 
                                  v-model="localValue"
                                  v-on:input="onInput">
                <template #button-content>
                  <b-icon-clock/>
                </template>
              </b-form-timepicker>
            </div>
          <div v-if="description != ''" class="mt-2">{{description}}</div>
          </div>
        </div>`,
  });
  Vue.component("input-date", {
    props: [
      "title",
      "id",
      "placeholder",
      "value",
      "error",
      "required",
      "validator",
      "labelInfoPopover",
      "description",
    ],
    data() {
      return {
        localValue: this.value,
      };
    },
    watch: {
      localValue(newValue) {
        this.$emit("input", newValue);
      },
    },
    methods: {
      onInput(event) {
        this.$emit("input", event);
        if (this.validator) {
          this.validator.$touch();
        }
      },
    },

    template: `
    <div class="col-md-6 mb-md-4 ">
      <div class="form-group form-date" :class="{'is-invalid': error, 'is-valid': !validator.$invalid && value.length > 0}">
        <div class="label"><span v-if="required">*</span>{{title}}</div>
         <div class="validation-cover">
          <b-form-datepicker
                            :id=id
                            locale="en"
                            reset-button
                            today-button
                            locale="en-GB"
                            :droprleft="true"
                            :right="true"
                            :no-flip="true"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            :placeholder="placeholder" 
                                v-model="localValue"
                                v-on:input="onInput">
              <template #button-content>
                <b-icon-calendar3/>
              </template>
            </b-form-datepicker>
          </div>
          <div v-if="description != ''" class="mt-2">{{description}}</div>
          </div>
        </div>`,
  });
  Vue.component("input-file", {
    props: [
      "title",
      "id",
      "placeholder",
      "value",
      "error",
      "required",
      "validator",
      "labelInfoPopover",
      "description",
    ],
    methods: {
        onInput(event) {
            //this.$refs[this.id].files = [];
            //onRemove(event)
        $("#" + this.id)
          .kendoUpload({
            multiple: false,
            async: {
              saveUrl: "/umbraco/api/ContactApi/SupportingDocumentationUpload",
              removeUrl:
                "/umbraco/api/ContactApi/SupportingDocumentationUploadRemove",
            },
            localization: {
              invalidFileExtension:
                '<div><strong>File upload error.</strong> File type not permitted.<br><span class="text-darkBlue">Additional files can be submitted later by replying to your confirmation email.<span></div>',
              invalidMaxFileSize:
                '<div><strong>File upload error.</strong> 10MB limit exceeded.<br><span class="text-darkBlue">Additional files can be submitted later by replying to your confirmation email.</span></div>',
              filesSumSizeLimit:
                '<div><strong>File upload error.</strong> 10MB limit exceeded.<br><span class="text-darkBlue">Additional files can be submitted later by replying to your confirmation email.</span></div>',
              select: "Browse",
            },
            // select: onSelect,
            success: onSuccess,
            remove: onRemove,
            validation: {
              allowedExtensions: [".json", ".txt", ".xml"],
              maxFileSize: 10485760,
            },
            dropZone: ".dropZoneElement",
            error: onError,
          })
          .data("kendoUpload");
        },
    },
    template: `
            <div class="col-md-6 mb-md-4 ">
                 <div class="form-group dropZoneElement">
                      <div class="label"><span v-if="required">*</span>{{title}}</div>
                          <b-form-file  
                              :id=id 
                              :required=required
                              v-on:input="onInput" 
                              :ref="id"
                              :data-customtitle="title"
                              accept=".json, .txt, .xml" 
                              :placeholder="placeholder"
                              drop-placeholder="Drop file here..."
                              class="">
                          </b-form-file>
                      <div v-if="description != ''" class="mt-2"><i>{{description}}</i></div>
                  </div>
            </div>`,
  });
  Vue.component("input-textarea", {
    props: [
      "title",
      "id",
      "placeholder",
      "value",
      "error",
      "maxLength",
      "required",
      "validator",
    ],
    template: `
      <div class="col-12">
        <div class="row">
          <div class="col-12">
              <div class="form-group m-0" :class="{'is-invalid': error, 'is-valid': !validator.$invalid && value.length > 0}">
                  <label :for="id"><span v-if="required">*</span>{{title}}</label>
                  <div class="validation-cover">
                      <textarea  
                          class="form-control" 
                          :id="id" 
                          rows="10"
                          autocomplete="off"
                          :placeholder="placeholder" 
                          v-bind:value="value"
                          v-on:input="$emit('input', $event.target.value), validator.$touch()"></textarea>
                  </div>
                  <div class="text-right mt-2 small" v-if="maxLength != null" :class="([value.length > maxLength ? 'text-danger' : 'text-blue'])">
                      <i>Maximum characters {{maxLength - value.length}}</i>
                  </div>
              </div>
          </div>
          <div class="col-md-6 mb-3" v-if="validator.$error && value.length == 0">
              <div class="text-danger mt-md-4">
                  <i>
                      *Mandatory Fields that<br />must be completed
                  </i>
              </div>
              <div class="text-danger mt-md-4" v-if="validator.$error && value.length > maxLength">
                  <i>
                      *Your {{title | lowercase}} must not<br />exceed {{maxLength}} characters
                  </i>
              </div>
          </div>
        </div>
      </div>`,
  });
  Vue.component("input-list", {
    props: [
      "title",
      "id",
      "value",
      "error",
      "items",
      "required",
      "optional",
      "nameId",
    ],
    template: `
            <div class="col-md-6" v-if="optional || nameId !== 'Cloud IX issue type'">                
                <label class="text-blue mb-3 d-block" :class="{'text-danger': error}"><span v-if="required">*</span>{{title}}</label>
                <div class="row">
                     <div class="col-md-6" v-for="item in items">
                        <div class="form-group  input-radio" :class="{'is-invalid': error}">
                            <input type="radio"  
                                :name="id" 
                                :id="id+item.id"
                                autocomplete="off"
                                v-bind:value="item.value"
                                v-on:input="$emit('input', $event.target.value)"/>
                            <label :for="id+item.id">{{item.text}}</label>
                        </div>                       
                    </div>
                </div>
            </div>`,
  });
  Vue.component("v-select", VueSelect.VueSelect);
  Vue.use(window.vuelidate.default);
  const { required, requiredIf, sameAs, email, numeric, maxLength, helpers } =
    window.validators;
  const phone = helpers.regex("phone", /^[0-9 ()+-]+$/);
  const length_greater = (value, vm) =>
    (vm.maxLength != null && helpers.len(value) <= vm.maxLength) ||
    vm.maxLength == null;

  vmFormQA = new Vue({
    el: "#formQA",
    data: () => ({
      showIssue: showIssue,
      disabledDates: {
        from: new Date(),
      },
      time: "",
      date: "",
      form: {
        componentList: componentList,
        firstNameQA: "",
        surnameQA: "",
        emailQA: "",
        emailQAConfirm: "",
        phoneQA: "",
        organisationQA: "",
        organisationIdQA: "",
        otherOrganisationQA: "",
        mprnQA: "",
        filesQA: [],
        tandcQA: false,
      },
      submitStatus: "",
      loading: false,
      organisationsQAList: [],
      showDropdownList: false,
      rcapt_sig_key: captchaKey,
      rcapt_id: 0,
      error: recaptchaError,
      serverSideErrors: [],
      info: null,
      isGasConsumerQuery:
        typeof isGasConsumerQuery !== "undefined"
          ? isGasConsumerQuery === "True"
            ? true
            : false
          : false,
      allowNotListedOrganisation:
        typeof allowNotListedOrganisation !== "undefined"
          ? allowNotListedOrganisation === "True"
            ? true
            : false
          : false,
      systemType: systemType,
      systemIssueType: systemIssueType,
    }),
    validations: {
      form: {
        componentList: {
          $each: {
            value: {
              validateEmail(value, vm) {
                if (vm.type === "email") {
                  return email(value);
                }
                return true;
              },
              required: requiredIf(function (e) {
                return e.name != "Cloud IX issue type"
                  ? e.required
                  : this.isOptional
                  ? true
                  : false;
              }),
              length_greater,
            },
          },
        },
        firstNameQA: {
          required,
          maxLength: maxLength(256),
        },
        surnameQA: {
          required,
          maxLength: maxLength(256),
        },
        emailQA: {
          required,
          maxLength: maxLength(100),
          email,
        },
        emailQAConfirm: {
          required,
          maxLength: maxLength(100),
          email,
          sameAsEmail: sameAs(() => vmFormQA.form.emailQA),
        },
        phoneQA: {
          required,
          phone,
          maxLength: maxLength(32),
        },
        organisationQA: {
          maxLength: maxLength(256),
          required: requiredIf(function () {
            return !this.isGasConsumerQuery;
          }),
          function() {
            return (
              (this.isGasConsumerQuery &&
                this.form.organisationQA.length == 0) ||
              (this.filteredItems != undefined &&
                this.filteredItems.length >= 1 &&
                this.form.organisationIdQA != "" &&
                this.form.organisationIdQA == this.filteredItems[0].id)
            );
          },
        },
        otherOrganisationQA: {
          required: requiredIf(function () {
            return this.form.organisationIdQA === -1;
          }),
        },
        mprnQA: {
          maxLength: maxLength(100),
        },
        tandcQA: {
          required,
          sameAs: sameAs(() => true),
        },
      },
    },
    methods: {
      updateData(value) {
        this.time = value;
      },
      updateValue(event) {
        this.value = event.target;
      },
      recaptchaCallback() {
        if (grecaptcha.getResponse().length == 0) {
          this.error = "Complete captcha challenge";
        } else {
          this.error = "";
        }
      },
      //addOrganisation() {
      //    this.form.organisationQA = this.otherOrganisationQA;
      //    this.otherOrganisationQA = "";
      //    this.showDropdownList = true
      //},
      organisationChanged() {
        this.form.organisationIdQA = "";
        this.form.otherOrganisationQA = "";
      },
      addFile(fileName) {
        this.form.filesQA.push(fileName);
      },
      removeFileByNameGuid(nameGuid) {
        if (this.form.filesQA && this.form.filesQA.length) {
          for (var i = 0; i < this.form.filesQA.length; i++) {
            if (this.form.filesQA[i].nameGuid === nameGuid) {
              this.form.filesQA.splice(i, 1);
              break;
            }
          }
        }
      },
      sendForm() {
        const self = this;
        let g_recaptcha_response = grecaptcha.getResponse();
        this.serverSideErrors = [];
        this.loading = true;
        var dataUrl = "/umbraco/api/ContactApi/FormSubmitSN";
        this.$v.form.$touch();
        if (this.$v.form.$invalid || g_recaptcha_response.length == 0) {
          this.submitStatus = "ERROR";
          this.recaptchaCallback();
          this.loading = false;
          $([document.documentElement, document.body]).animate(
            {
              scrollTop: $("form").offset().top - 100,
            },
            1000,
          );
        } else {
          this.error = "";
          this.loading = true;
          var componentsFiltered = self.form.componentList.map(function (x) {
            if (x.type == "dropdown") {
              return {
                id: x.id,
                value: x.value.value,
                uid: x.uid,
              };
            } else {
              return {
                id: x.id,
                value: x.value,
                uid: x.uid,
              };
            }
          });
          axios
            .post(
              dataUrl,
              {
                IsGasConsumerQuery: self.isGasConsumerQuery.toString(),
                SystemType: self.systemType,
                SystemIssueType: self.systemIssueType,
                FirstName: self.form.firstNameQA,
                Surname: self.form.surnameQA,
                Email: self.form.emailQA,
                Phone: self.form.phoneQA,
                OrganisationId: self.form.organisationIdQA,
                OrganisationOther: self.form.otherOrganisationQA,
                Mprn: self.form.mprnQA,
                Components: componentsFiltered,
                Files: self.form.filesQA,
                CaptchaVerification: g_recaptcha_response,
              },
              {
                headers: {
                  "Content-Type": "application/json; charset=utf-8",
                },
              },
            )
            .then((response) => {
              this.info = response.data;
              this.loading = false;
              logGAEvent(
                "Help & Support",
                "Form Submit Success",
                document.location.href,
              );
              $([document.documentElement, document.body]).animate(
                {
                  scrollTop: $("form").offset().top - 100,
                },
                2000,
              );
            })
            .catch((error) => {
              if (error.response.data) {
                if (error.response.data.ResponseCode) {
                  this.info = error.response.data;
                } else {
                  if (error.response.data.constructor === Array) {
                    for (var i = 0; i < error.response.data.length; i++) {
                      this.serverSideErrors.push(error.response.data[i]);
                    }
                  } else {
                    if (error.response.data.Message) {
                      this.serverSideErrors.push(
                        error.response.data.Message + " " + unexpectedErrorMsg,
                      );
                    } else {
                      this.serverSideErrors.push(error.response.data);
                    }
                  }
                  grecaptcha.reset();
                  $([document.documentElement, document.body]).animate(
                    {
                      scrollTop: $("form").offset().top - 100,
                    },
                    2000,
                  );
                }
              }
              this.loading = false;
            });
        }
      },
      getOrganisations() {
        axios
          .get(
            "/umbraco/api/ContactApi/GetOrganisationList?gasSupplierList=" +
              this.isGasConsumerQuery.toString(),
          )
          .then((response) => (this.organisationsQAList = response.data));
      },
      matchWords: function (subject, words) {
        return words.every((el) =>
          subject.toLowerCase().includes(el.toLowerCase()),
        );
      },
      back() {
        location.reload();
      },
      selectOrganisation(item) {
        (this.form.organisationQA = item.combinedTitle),
          (this.form.organisationIdQA = item.id),
          (this.showDropdownList = false);
      },
      changePlaceholder() {
        const el = $("#description");
        if (!this.form.componentList.some((i) => i.name === "IX version")) {
          return;
        }

        if (this.isOptional) {
          el.attr(
            "placeholder",
            `Eg "I can't see my files" or "my SFTP isn't working correctly"`,
          );
        } else {
          el.attr(
            "placeholder",
            `Eg "I can't see my files" or "My connectivity has been lost"`,
          );
        }
      },
    },
    mounted() {
      this.changePlaceholder();
      this.getOrganisations();
      Vue.nextTick(function () {
        popoverFix();
      });
    },
    computed: {
      isOptional() {
        return this.form.componentList.some(
          (i) => i.name === "IX version" && i.value.includes("Cloud IX"),
        );
      },
      //   showOptional(){
      //     return this.isOptional &&
      //   },
      hideIssues() {
        return this.showIssue || this.form.componentList.length != 0;
      },
      showResponseMsg() {
        return this.info == null || this.info == undefined;
      },
      showDropdown() {
        if (
          this.filteredItems &&
          this.filteredItems.length &&
          this.filteredItems != "undefined" &&
          this.showDropdownList
        ) {
          return true;
        } else {
          return false;
        }
      },

      filteredItems() {
        const rg = this.form.organisationQA
          .split(/(\s+)/)
          .filter((e) => e.trim().length > 0);
        //if (this.form.organisationQA) {
        //    return this.organisationsQAList.filter(i => this.matchWords(i.combinedTitle, rg))
        //}
        const other = this.allowNotListedOrganisation
          ? [
              {
                id: -1,
                shortCode: "OTHER",
                name: "Organisation not listed?",
                combinedTitle: "Organisation not listed?",
                gasSupplier: false,
              },
            ]
          : [];
        if (this.form.organisationQA) {
          let fullMatchHandler = this.organisationsQAList.filter(
            (i) => i.combinedTitle === this.form.organisationQA,
          );
          if (fullMatchHandler.length === 1) {
            return this.organisationsQAList.filter(
              (i) => i.combinedTitle === this.form.organisationQA,
            );
          } else {
            if (this.allowNotListedOrganisation) {
              return other.concat(
                this.organisationsQAList.filter((i) =>
                  this.matchWords(i.combinedTitle, rg),
                ),
              );
            } else {
              return this.organisationsQAList.filter((i) =>
                this.matchWords(i.combinedTitle, rg),
              );
            }
          }
        }
      },
    },
    watch: {
      loading() {
        if (this.loading) {
          $("html").addClass("loading");
        } else {
          $("html").removeClass("loading");
        }
      },
      isOptional() {
        this.changePlaceholder();
      },
    },
  });
}
var uploadFilesSum = 0;
var upload = $("#filesQA").data("kendoUpload");

function onSelect(e) {
  $.each(e.files, function (index, value) {
    if (
      uploadFilesSum > fileSizeLimit ||
      value.size > fileSizeLimit ||
      uploadFilesSum + value.size > fileSizeLimit ||
      $(".k-file[data-uid]").length > limitOfFileNumber - 1 ||
      $(".k-file[data-uid]").length + index > limitOfFileNumber - 1
    ) {
      var files = e.files;
      files[index].validationErrors = ["filesSumSizeLimit"];
      var uid = files[index].uid;
      var entry = $(".k-file[data-uid='" + uid + "']");
      if (entry.length > 0) {
        entry.remove();
      }
    } else {
      if (!e.files[0].validationErrors) {
        uploadFilesSum += value.size;
      }
    }
  });
}
function onError(e) {
  var files = e.files;
  for (var i = 0; i < files.length; i++) {
    var uid = files[i].uid;
    var entry = $(".k-file[data-uid='" + uid + "']");
    if (entry.length > 0) {
      entry.remove();
    }
  }
}
function getFileInfo(e) {
  var files = e.files;
  for (var i = 0; i < files.length; i++) {
    return files[i].size;
  }
}

function onSuccess(e) {
  if (e.operation !== "remove") {
    var file = e.files[0];
    file.nameGuid = e.response;
    file.id = e.sender.element[0].id;
    file.title = e.sender.element[0].dataset.customtitle;
    vmFormQA.addFile(file);
  }
}

function onRemove(e) {
  vmFormQA.removeFileByNameGuid(e.files[0].nameGuid);

  if (uploadFilesSum >= getFileInfo(e) && !e.files[0].validationErrors) {
    uploadFilesSum -= getFileInfo(e);
  }
  e.data = {
    nameGuid: e.files[0].nameGuid,
  };
}

$("#filesQA").kendoUpload({
  async: {
    saveUrl: "/umbraco/api/ContactApi/SupportingDocumentationUpload",
    removeUrl: "/umbraco/api/ContactApi/SupportingDocumentationUploadRemove",
  },
  localization: {
    invalidFileExtension:
      '<div><strong>File upload error.</strong> File type not permitted.<br><span class="text-darkBlue">Additional files can be submitted later by replying to your confirmation email.<span></div>',
    invalidMaxFileSize:
      '<div><strong>File upload error.</strong> 10MB limit exceeded.<br><span class="text-darkBlue">Additional files can be submitted later by replying to your confirmation email.</span></div>',
    filesSumSizeLimit:
      '<div><strong>File upload error.</strong> 10MB limit exceeded.<br><span class="text-darkBlue">Additional files can be submitted later by replying to your confirmation email.</span></div>',
    dropFilesHere: "Drag and drop files here or ",
    select: "Browse",
  },
  select: onSelect,
  success: onSuccess,
  remove: onRemove,
  validation: {
    allowedExtensions: allowedExtensions,
    maxFileSize: fileSizeLimit,
  },
  error: onError,
});
